module.exports = __webpack_public_path__ + "static/img/semi-heavy-horse-bluegrey.d6fa90e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-horse-bluegrey.svg
// module id = FAG5
// module chunks = 74